// extracted by mini-css-extract-plugin
module.exports = {"hero":"blog-module--hero--TCejO"};